module.exports = __webpack_public_path__ + "static/media/Lancaster-Uni.a0b864da.png";